import { render, staticRenderFns } from "./NotificationsWrapper.vue?vue&type=template&id=646c93db"
import script from "./NotificationsWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationsWrapper.vue?vue&type=script&lang=js"
import style0 from "./NotificationsWrapper.vue?vue&type=style&index=0&id=646c93db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports